import "./i18n";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import { AppProviders } from "./providers/AppProviders";
import "./index.css";
import { initWsClient } from "./server/request";
import { wssUrl } from "./config";
/** ES2022 Object.hasOwn 在旧运行环境 / 当前 lib 下需补全 */
type ObjectWithHasOwn = ObjectConstructor & {
  hasOwn?: (object: object, property: PropertyKey) => boolean;
};
const ObjectGlobal = Object as ObjectWithHasOwn;
if (typeof ObjectGlobal.hasOwn !== "function") {
  ObjectGlobal.hasOwn = (object: object, property: PropertyKey) =>
    Object.prototype.hasOwnProperty.call(object, property);
}

// 初始化 WebSocket 客户端
if (wssUrl) {
  initWsClient(wssUrl);
}

createRoot(document.getElementById("root")!).render(
  <AppProviders>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AppProviders>
);
